<template>
  <kFieldWrapper>
    <div class="k-form-field-wrap">
      <KTextBox
        :valid="props.valid"
        :id="props.id"
        :value="props.value"
        :disabled="props.disabled"
        :placeholder="placeHolderText"
        :label="labelText"
        :type="props.additionalProperties?.type || props.type"
        :aria-required="props.addAsterisk ? 'true' : undefined"
        @input="changeHandler($event)"
        @blur="blurHandler($event)"
        @focus="focusHandler($event)"
      ></KTextBox>
      <kError
        :id="errorId"
        v-if="showValidationMessage"
      >
        {{ validationMessage }}
      </kError>
      <kHint
        :id="hintId"
        v-else
        >{{ hint }}</kHint
      >
    </div>
  </kFieldWrapper>
</template>

<script setup lang="ts">
import { FieldWrapper as kFieldWrapper } from "@progress/kendo-vue-form";
import { TextBox as KTextBox } from '@progress/kendo-vue-inputs'
import {
  Error as kError,
  Hint as kHint,
} from "@progress/kendo-vue-labels";
import { computed, ref } from "vue";
import { useLogger } from "vue-logger-plugin";
const logger = useLogger();

const props = defineProps({
  optional: Boolean,
  disabled: Boolean,
  placeholder: String,
  addAsterisk: Boolean,
  touched: Boolean,
  label: String,
  validationMessage: String,
  hint: String,
  additionalProperties: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: String,
    default: "text",
  },
  id: String,
  valid: Boolean,
  value: {
    type: String,
    default: "",
  }
});

const emit = defineEmits(["change", "blur", "focus"]);

const showValidationMessage = computed(
  () => props.touched && props.validationMessage,
);
const showHint = computed(() => !showValidationMessage.value && props.hint);
const hintId = computed(() => (showHint.value ? `${props.id}_hint` : ""));
const errorId = computed(() =>
  showValidationMessage.value ? `${props.id}_error` : "",
);

const isFocused = ref(false);

const placeHolderText = ref(props.placeholder);
const labelText = ref(props.label);

if (props.addAsterisk) {
  placeHolderText.value = props.placeholder + " *";
  labelText.value = props.label + " *";
}

if (props.placeholder === undefined) {
  placeHolderText.value = "";
}

function changeHandler(event: any) {
  logger.debug("event:", event);
  emit("change", event);
  isFocused.value = true;
}
function blurHandler(e: any) {
  emit("blur", e);
  isFocused.value = false;
}
function focusHandler(e: any) {
  emit("focus", e);
  isFocused.value = true;
}
</script>
